export class BoundedDate {
  static isCalendarDate(raw: string): boolean {
    if (!/^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/.test(raw)) return false;
    const year = Number(raw.slice(0, 4));
    const month = Number(raw.slice(5, 7));
    const day = Number(raw.slice(8, 10));
    if (year < 1000) return false;
    const dt = new Date(year, month - 1, day);
    return dt.getFullYear() === year && dt.getMonth() === month - 1 && dt.getDate() === day;
  }

  static chosen(inputRaw: string, changeRaw: string, min: string): string {
    const input = inputRaw.trim();
    return BoundedDate.isCalendarDate(input) && Boolean(min) && input < min ? input : changeRaw;
  }

  static capInput(raw: string, _min: string, max = ""): string {
    const trimmed = raw.trim();
    if (!trimmed || !BoundedDate.isCalendarDate(trimmed)) return trimmed;
    if (max && trimmed > max) return max;
    return trimmed;
  }

  static finishInput(raw: string, _min: string, max = ""): string {
    const trimmed = raw.trim();
    if (!trimmed) return "";
    if (!BoundedDate.isCalendarDate(trimmed)) return trimmed;
    if (max && trimmed > max) return max;
    return trimmed;
  }

  static toDisplay(iso: string): string {
    if (!BoundedDate.isCalendarDate(iso)) return "";
    return `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}`;
  }

  static shown(raw: string): string {
    return BoundedDate.toDisplay(raw) || raw;
  }

  static parseTyped(raw: string): string | null {
    const trimmed = raw.trim();
    if (!trimmed) return "";
    if (BoundedDate.isCalendarDate(trimmed)) return trimmed;
    const match = trimmed.match(/^(\d{1,2})[/.\-](\d{1,2})[/.\-](\d{4})$/);
    if (!match) return null;
    const iso = `${match[3]}-${match[2].padStart(2, "0")}-${match[1].padStart(2, "0")}`;
    return BoundedDate.isCalendarDate(iso) ? iso : null;
  }
}

export class EnteredDateValidator {
  message(raw: string, invalidMessage: string): string | undefined {
    const trimmed = raw.trim();
    if (!trimmed) return undefined;
    if (BoundedDate.isCalendarDate(trimmed)) return undefined;
    return invalidMessage;
  }
}
